












import Vue from 'vue'
import { generateUUID } from '@/utils/helpers'
import { sleep } from '@/utils/helpers'

export default Vue.extend({
  name: 'ImgGuard',
  props: {
    src: {
      type: String,
      default: ''
    },
    isLazy: {
      type: Boolean,
      default: false
    },
    fadeIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFadein: false
    }
  },
  computed: {
    klass(): any {
      return {
        'is-fadein': this.isFadein
      }
    }
  },
  watch: {
    src: {
      immediate: true,
      async handler(val: string, old: string) {
        if (!this.fadeIn || !old) return

        this.isFadein = true
        await sleep(1000)
        this.isFadein = false
      }
    }
  },
  methods: {
    generateUUID: generateUUID
  }
})
